var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPdf(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.90249 0H16.0305L23.2053 7.17614V20.9565C23.2053 22.6298 21.8365 24 20.1618 24H7.90254C6.2292 24 4.86035 22.6298 4.86035 20.9565V3.04355C4.86035 1.3702 6.2292 0 7.90249 0Z",
    fill: "#FF5F7A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0303 0L23.2051 7.17614H16.8039C16.3773 7.17614 16.0303 6.82777 16.0303 6.4012V0Z",
    fill: "#FB4455"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.46289 10.2197H17.9919C18.3595 10.2197 18.6598 10.5201 18.6598 10.8877V16.9514C18.6598 17.319 18.3595 17.6194 17.9919 17.6194H1.46289C1.0953 17.6194 0.794922 17.319 0.794922 16.9514V10.8877C0.794922 10.5201 1.09534 10.2197 1.46289 10.2197Z",
    fill: "#FB4455"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M5.51999 11.4561H4.27321C4.05923 11.4561 3.88574 11.6295 3.88574 11.8435V13.8872V14.3905V15.9939C3.88574 16.2079 4.05923 16.3814 4.27321 16.3814C4.4872 16.3814 4.66068 16.2079 4.66068 15.9939V14.778H5.51995C6.42107 14.778 7.1542 14.0449 7.1542 13.1438V13.0903C7.15424 12.1892 6.42112 11.4561 5.51999 11.4561ZM6.3793 13.1437C6.3793 13.6176 5.9938 14.003 5.51999 14.003H4.66068V13.8871V12.2309H5.51995C5.99376 12.2309 6.37926 12.6164 6.37926 13.0902L6.3793 13.1437ZM9.68962 11.4561H8.44288C8.2289 11.4561 8.05541 11.6295 8.05541 11.8435V15.9939C8.05541 16.2079 8.2289 16.3814 8.44288 16.3814H9.68962C10.5907 16.3814 11.3239 15.6483 11.3239 14.7472V13.0903C11.3239 12.1892 10.5907 11.4561 9.68962 11.4561ZM10.5489 14.7471C10.5489 15.221 10.1634 15.6064 9.68962 15.6064H8.83035V12.2309H9.68962C10.1634 12.2309 10.5489 12.6164 10.5489 13.0902V14.7471ZM13.0754 12.231V13.3036H14.8715C15.0854 13.3036 15.2589 13.4771 15.2589 13.6911C15.2589 13.905 15.0854 14.0785 14.8715 14.0785H13.0754V15.9939C13.0754 16.2079 12.9019 16.3814 12.6879 16.3814C12.4739 16.3814 12.3004 16.2079 12.3004 15.9939V11.8435C12.3004 11.6295 12.4739 11.4561 12.6879 11.4561H15.1814C15.3954 11.4561 15.5689 11.6295 15.5689 11.8435C15.5689 12.0575 15.3954 12.231 15.1814 12.231H13.0754Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/Pdf.1ce546432c94c9726aed00cb5bf68bd7.svg";
export { ForwardRef as ReactComponent };